import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e127935e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1 primary-text" }, "Skill Needs", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary align-self-center fw-bolder add-text" }, "ADD ONE", -1))
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          value: "1",
          "data-kt-check": "true",
          "data-kt-check-target": ".widget-13-check"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Key Skill"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Priority"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Budget"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Start"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Deliver"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Actions")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input widget-13-check",
      type: "checkbox",
      value: "1"
    })
  ])
], -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  href: "#",
  class: "primary-text text-hover-primary fs-6"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  href: "#",
  class: "primary-text text-hover-primary fs-6"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  href: "#",
  class: "primary-text text-hover-primary fs-6"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "primary-text text-hover-primary fs-6" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  href: "#",
  class: "primary-text text-hover-primary fs-6"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  href: "#",
  class: "primary-text text-hover-primary fs-6"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "svg-icon svg-icon-3" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "svg-icon svg-icon-3" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" See Experts ")
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "svg-icon svg-icon-3" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "svg-icon svg-icon-3" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input widget-13-check",
      type: "checkbox",
      value: "1"
    })
  ])
], -1))
const _hoisted_38 = { class: "primary-text text-hover-primary fs-6" }
const _hoisted_39 = { class: "svg-icon svg-icon-3" }
const _hoisted_40 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_EditProfileModal = _resolveComponent("EditProfileModal")!
  const _component_EditProfileDropdown = _resolveComponent("EditProfileDropdown")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_NeedExpertDrawer = _resolveComponent("NeedExpertDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "d-flex add-skill-container cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCreateProjectNeed && _ctx.onCreateProjectNeed(...args)))
        }, [
          _createVNode(_component_el_icon, {
            class: "text-primary",
            size: 18
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CirclePlus)
            ]),
            _: 1
          }),
          _hoisted_4
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectNeeds, (projectNeed, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _hoisted_9,
                _createElementVNode("td", null, [
                  (_ctx.modes[index] === 'edit')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.name) = $event)),
                        placeholder: "Name...",
                        class: "text-field form-control form-control-sm form-control-solid"
                      }, null, 512)), [
                        [_vModelText, _ctx.payload.name]
                      ])
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("a", _hoisted_11, _toDisplayString(projectNeed.name ? projectNeed.name : "N/A"), 1)
                      ]))
                ]),
                _createElementVNode("td", null, [
                  (_ctx.modes[index] === 'edit')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          class: "btn btn-secondary btn-sm",
                          "data-kt-menu-trigger": "click",
                          "data-kt-menu-attach": "parent",
                          "data-kt-menu-placement": "top",
                          "data-kt-menu-flip": "top"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(!_ctx.payload.skillId ? "Select Skill" : _ctx.selectedValues.skill), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_EditProfileModal, {
                          "dropdown-menu-items": _ctx.skillsWithGroups,
                          "has-submenu": true,
                          onItemClicked: _ctx.onSelectSkill
                        }, null, 8, ["dropdown-menu-items", "onItemClicked"])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (projectNeed.skills)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_13, _toDisplayString(projectNeed.skills.name), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.onEditProjectNeed(index, projectNeed)),
                              class: "badge badge-secondary cursor-pointer"
                            }, "Set/Add", 8, _hoisted_14))
                      ]))
                ]),
                _createElementVNode("td", null, [
                  (_ctx.modes[index] === 'edit')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          class: "btn btn-secondary btn-sm",
                          "data-kt-menu-trigger": "click",
                          "data-kt-menu-attach": "parent",
                          "data-kt-menu-placement": "top",
                          "data-kt-menu-flip": "top"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(!_ctx.payload.priorityLevelId
                          ? "Select Priority"
                          : _ctx.selectedValues.priority), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_EditProfileDropdown, {
                          "dropdown-menu-items": _ctx.priorityLevels,
                          onItemClicked: _ctx.onSelectPriorityLevel
                        }, null, 8, ["dropdown-menu-items", "onItemClicked"])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (projectNeed.priorityLevel)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["badge", 
                        projectNeed.priorityLevel
                          ? _ctx.getPriorityBadgeColor(
                              projectNeed.priorityLevel.name
                            )
                          : 'badge-light'
                      ])
                            }, _toDisplayString(projectNeed.priorityLevel.name), 3))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.onEditProjectNeed(index, projectNeed)),
                              class: "badge badge-secondary cursor-pointer"
                            }, "Set/Add", 8, _hoisted_16))
                      ]))
                ]),
                _createElementVNode("td", null, [
                  (_ctx.modes[index] === 'edit')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          class: "btn btn-secondary btn-sm",
                          "data-kt-menu-trigger": "click",
                          "data-kt-menu-attach": "parent",
                          "data-kt-menu-placement": "top",
                          "data-kt-menu-flip": "top"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(!_ctx.payload.budget
                          ? "Select Budget"
                          : Number(_ctx.payload.budget).toLocaleString()), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_EditProfileDropdown, {
                          unit: "€",
                          "dropdown-menu-items": _ctx.budgetValuesInEuroFormat,
                          onItemClicked: _ctx.onSelectBudget
                        }, null, 8, ["dropdown-menu-items", "onItemClicked"])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (projectNeed.budget)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_18, _toDisplayString(Number(projectNeed.budget).toLocaleString()), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.onEditProjectNeed(index, projectNeed)),
                              class: "badge badge-secondary cursor-pointer"
                            }, "Set/Add", 8, _hoisted_19))
                      ]))
                ]),
                _createElementVNode("td", _hoisted_20, [
                  (_ctx.modes[index] === 'edit')
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 0,
                        style: {"width":"10rem"},
                        size: "small",
                        modelValue: _ctx.payload.startDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.startDate) = $event)),
                        type: "date",
                        placeholder: "Start date"
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (projectNeed.startDate)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_22, _toDisplayString(new Date(projectNeed.startDate).toDateString()), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.onEditProjectNeed(index, projectNeed)),
                              class: "badge badge-secondary cursor-pointer"
                            }, "Set/Add", 8, _hoisted_23))
                      ]))
                ]),
                _createElementVNode("td", null, [
                  (_ctx.modes[index] === 'edit')
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 0,
                        style: {"width":"10rem"},
                        size: "small",
                        modelValue: _ctx.payload.endDate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.endDate) = $event)),
                        type: "date",
                        placeholder: "End date"
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (projectNeed.endDate)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_25, _toDisplayString(new Date(projectNeed.endDate).toDateString()), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.onEditProjectNeed(index, projectNeed)),
                              class: "badge badge-secondary cursor-pointer"
                            }, "Set/Add", 8, _hoisted_26))
                      ]))
                ]),
                _createElementVNode("td", null, [
                  (_ctx.modes[index] === 'edit')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.onUpdateProjectNeed(projectNeed.id, index)),
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                        }, [
                          _createElementVNode("span", _hoisted_28, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen037.svg" })
                          ])
                        ], 8, _hoisted_27),
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.onExitEditMode(index)),
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                        }, [
                          _createElementVNode("span", _hoisted_30, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen034.svg" })
                          ])
                        ], 8, _hoisted_29)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          plain: "",
                          class: "me-1 see-expert-btn",
                          onClick: ($event: any) => (_ctx.$refs.needExpertDrawer.showDrawer(projectNeed.skills.name))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.onEditProjectNeed(index, projectNeed)),
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                        }, [
                          _createElementVNode("span", _hoisted_33, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_32),
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.onDeleteProjectNeed(projectNeed.id)),
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                        }, [
                          _createElementVNode("span", _hoisted_35, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                          ])
                        ], 8, _hoisted_34)
                      ], 64))
                ])
              ]))
            }), 128)),
            (_ctx.currentMode === 'create')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.name) = $event)),
                      placeholder: "Name...",
                      class: "text-field form-control form-control-sm form-control-solid"
                    }, null, 512), [
                      [_vModelText, _ctx.payload.name]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      class: "btn btn-secondary btn-sm",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-attach": "parent",
                      "data-kt-menu-placement": "top",
                      "data-kt-menu-flip": "top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(!_ctx.payload.skillId ? "Select Skill" : _ctx.selectedValues.skill), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_EditProfileModal, {
                      "dropdown-menu-items": _ctx.skillsWithGroups,
                      "has-submenu": true,
                      onItemClicked: _ctx.onSelectSkill
                    }, null, 8, ["dropdown-menu-items", "onItemClicked"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      class: "btn btn-secondary btn-sm",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-attach": "parent",
                      "data-kt-menu-placement": "top",
                      "data-kt-menu-flip": "top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(!_ctx.payload.priorityLevelId
                      ? "Select Priority"
                      : _ctx.selectedValues.priority), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_EditProfileDropdown, {
                      "dropdown-menu-items": _ctx.priorityLevels,
                      onItemClicked: _ctx.onSelectPriorityLevel
                    }, null, 8, ["dropdown-menu-items", "onItemClicked"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      class: "btn btn-secondary btn-sm",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-attach": "parent",
                      "data-kt-menu-placement": "top",
                      "data-kt-menu-flip": "top"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(!_ctx.payload.budget
                      ? "Select Budget"
                      : Number(_ctx.payload.budget).toLocaleString()), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_EditProfileDropdown, {
                      unit: "€",
                      "dropdown-menu-items": _ctx.budgetValuesInEuroFormat,
                      onItemClicked: _ctx.onSelectBudget
                    }, null, 8, ["dropdown-menu-items", "onItemClicked"])
                  ]),
                  _createElementVNode("td", _hoisted_38, [
                    _createVNode(_component_el_date_picker, {
                      style: {"width":"10rem"},
                      size: "small",
                      modelValue: _ctx.payload.startDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.startDate) = $event)),
                      type: "date",
                      placeholder: "Start date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_date_picker, {
                      style: {"width":"10rem"},
                      size: "small",
                      modelValue: _ctx.payload.endDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.endDate) = $event)),
                      type: "date",
                      placeholder: "End date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAddProjectNeed && _ctx.onAddProjectNeed(...args))),
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                    }, [
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen037.svg" })
                      ])
                    ]),
                    _createElementVNode("a", {
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onExitCreateMode && _ctx.onExitCreateMode(...args))),
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                    }, [
                      _createElementVNode("span", _hoisted_40, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen034.svg" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ]),
    _createVNode(_component_NeedExpertDrawer, { ref: "needExpertDrawer" }, null, 512)
  ], 2)), [
    [_directive_loading, _ctx.loading]
  ])
}